import { profileModuleQuery, useModule } from 'system/structure-modules';

export default function ProfileInstanceScreen() {
    const { ProfileScreen } = useModule(profileModuleQuery);
    return <ProfileScreen />;
}
